import { RootState } from 'store'

export const chatSelectors = {
  selectChats: (state: RootState) => state.chat.chats,
  selectActiveChat: (state: RootState) => state.chat.activeChat,
  selectMessages: (state: RootState) => state.chat.messages,
  selectUnreadCount: (state: RootState) => state.chat.unreadCount,
  selectIsChatsLoading: (state: RootState) => state.chat.isChatsLoading,
  selectIsChatLoading: (state: RootState) => state.chat.isChatLoading,
  selectIsMessagesLoading: (state: RootState) => state.chat.isMessagesLoading,
  selectError: (state: RootState) => state.chat.error
}

